import type { MenuItem } from "../../shared/types"

export const isAdminMenuItemActive = (menuItem: MenuItem): boolean => window.location.pathname === menuItem.path
